declare namespace $ {

	type $shm_dashboard_admin_user_dashboards_follower__offset_shm_dashboard_admin_user_dashboards_auto_update_1 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['bubble_offset'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_follower['offset'] >
	>
	type $shm_dashboard_admin_user_dashboards_follower__align_shm_dashboard_admin_user_dashboards_auto_update_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['bubble_align'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_follower['align'] >
	>
	type $shm_dashboard_admin_user_dashboards_follower__Anchor_shm_dashboard_admin_user_dashboards_auto_update_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['Anchor'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_follower['Anchor'] >
	>
	type $shm_dashboard_admin_user_dashboards_follower__Sub_shm_dashboard_admin_user_dashboards_auto_update_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_admin_user_dashboards_auto_update['Bubble'] >
		,
		ReturnType< $shm_dashboard_admin_user_dashboards_follower['Sub'] >
	>
	export class $shm_dashboard_admin_user_dashboards_auto_update extends $mol_pick {
		Follower( ): $shm_dashboard_admin_user_dashboards_follower
	}
	
}

//# sourceMappingURL=update.view.tree.d.ts.map